import { useContext } from 'react';
import { LocalizerContext } from '../components/hoc/Localizer';

const useLocale = () => {
  const locale = useContext(LocalizerContext);
  return locale;
};

export default useLocale;
